import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { siteContent } from '../data/mock';

const ForWhomSection = () => {
  const { forWhom } = siteContent;

  return (
    <section className="for-whom-section section-padding" data-testid="for-whom-section" data-reveal="fade">
      <div className="container">
        <h2 className="section-title-center">Para quem é (e para quem não é)</h2>

        <div className="for-whom-grid">
          <div className="content-card for-card" data-testid="for-whom-yes">
            <div className="for-icon-positive">
              <CheckCircle2 size={32} strokeWidth={1.5} />
            </div>
            <h3 className="for-title">{forWhom.forTitle}</h3>
            <ul className="for-list">
              {forWhom.forList.map((item, index) => (
                <li key={index} className="for-item">
                  <CheckCircle2 size={18} strokeWidth={2} className="check-icon-small" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="content-card not-for-card" data-testid="for-whom-no">
            <div className="for-icon-negative">
              <XCircle size={32} strokeWidth={1.5} />
            </div>
            <h3 className="for-title">{forWhom.notForTitle}</h3>
            <ul className="for-list">
              {forWhom.notForList.map((item, index) => (
                <li key={index} className="for-item">
                  <XCircle size={18} strokeWidth={2} className="x-icon-small" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForWhomSection;
